import user from "./jsonSchema/user";
import countries from "./jsonSchema/countries";

export default {
  user,
  countries,
};
